import { render, staticRenderFns } from "./Calculator.vue?vue&type=template&id=084ef82a&scoped=true"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"
import style0 from "./Calculator.vue?vue&type=style&index=0&id=084ef82a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ef82a",
  null
  
)

export default component.exports